import React from "react"

import Layout from "../components/layout"
import SEO from "../components/seo"

const IndexPage = () => (
  <Layout>
    <SEO title="Home" />
    <h2>Fast in every way that matters</h2>
    <p>Gatsby is a free and open source framework
    based on React that helps developers build blazing
    fast websites and apps</p>
  </Layout>
)

export default IndexPage
